import {action, computed, observable} from 'mobx';
import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from 'spa/state/_util/api-request';

class CalculateCreateState extends APIRequestState {
  putRequest(urlId, ...params) {
    this.reset();
    return this.ctx.sdk.post(`/orders/${urlId}/ecommerce/orders/calculate-create`, ...params);
  }
}

class CreateState extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/orders/${urlId}/ecommerce/orders`, ...params);
  }
}

class GetBasketState extends APIRequestState {
  getRequest(urlIds, ...params) {
    const {orderId, basketId} = urlIds;
    this.reset();
    return this.ctx.sdk.get(`/orders/${orderId}/ecommerce/basket/${basketId}`);
  }
}

class EcommerceState {
  /*
   * Lazy load our required state
   */
  @lazyInitialize @nonenumerable calculateCreate = new CalculateCreateState(this.ctx);
  @lazyInitialize @nonenumerable create = new CreateState(this.ctx);
  @lazyInitialize @nonenumerable getBasket = new GetBasketState(this.ctx);

  @observable basket = undefined;
  @observable basketTotalItems = 0;
  @observable basketProducts = undefined;
  @observable bookingId = undefined;
  @observable shippingAddress= undefined;
  @observable bookingAddress = undefined;
  @observable currency = undefined;
  @observable isNewAddress = false;
  @observable newAddressValidated = false;
  @observable storageData = {};
  @observable heroId = undefined;
  @observable isHeroOrder = false;
  @observable basketId = undefined;

  /*
   * Setup our observables for our payment information
   */
  @observable paymentInfo = {
    /* card, paypal or applepay */
    paymentOption: undefined,
    paymentToken: undefined,
  };

  @nonenumerable
  listeners = [];

  @action reset() {
    this.basket = undefined;
    this.basketTotalItems = 0;
    this.basketProducts = undefined;
    this.bookingId = undefined;
    this.shippingAddress = undefined;
    this.bookingAddress = undefined;
    this.currency = undefined;
    this.isNewAddress = false;
    this.newAddressValidated = false;
    this.storageData = {};
    this.heroId = undefined;
    this.isHeroOrder = false;
    this.basketId = undefined;
    this.paymentInfo = {
      paymentOption: undefined,
      paymentToken: undefined,
    };
    this.create.reset();
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default EcommerceState;



// WEBPACK FOOTER //
// ./spa/state/ecommerce.jsx